export const DEAL_NAME_INPUT_TEST_ID = 'DEAL_NAME_INPUT_TEST_ID';
export const DEAL_STAGE_INPUT_TEST_ID = 'DEAL_STAGE_INPUT_TEST_ID';
export const DEAL_LEAD_INPUT_TEST_ID = 'DEAL_LEAD_INPUT_TEST_ID';
export const DEAL_BROKER_INPUT_TEST_ID = 'DEAL_BROKER_INPUT_TEST_ID';
export const DEAL_ILO_INPUT_TEST_ID = 'DEAL_ILO_INPUT_TEST_ID';
export const DEAL_SELLER_INPUT_TEST_ID = 'DEAL_SELLER_INPUT_TEST_ID';
export const DEAL_NOTE_INPUT_TEST_ID = 'DEAL_NOTE_INPUT_TEST_ID';
export const DEAL_DESCRIPTION_INPUT_TEST_ID = 'DEAL_DESCRIPTION_INPUT_TEST_ID';
